import { DisparoAutomaticoModel } from './disparo-automatico.model';
import { FrequenciaRecorrencia, PosicaoSemanaMes, TipoRecorrenciaMensal, TipoTerminoRecorrencia, UnidadePersonalizada } from './recorrencia.enums';

export class ProgramacaoDisparoModel {
  id?: number;
  uuid?: string;
  ativo?: boolean;
  programacaoId?: number;
  disparoId?: number;
  recorrente?: boolean;
  status?: string;
  dataCriacao?: string;
  frequencia?: FrequenciaRecorrencia;
  intervalo = 1;
  unidadePersonalizada?: UnidadePersonalizada;
  diasSemana: number[] = [];
  tipoRecorrenciaMensal?: TipoRecorrenciaMensal;
  diaMes?: number;
  ultimoDiaMes?: boolean;
  posicaoSemanaMes?: PosicaoSemanaMes;
  diaSemanaMes?: number;
  dataInicio?: string;
  hora?: string;
  horarios: string[] = [];
  tipoTermino: TipoTerminoRecorrencia = 'Nunca';
  dataTermino?: string;
  numeroEnviosTermino?: number;
  disparo?: DisparoAutomaticoModel;
  enviosRealizados?: number;
  proximaExecucao?: string;
  quantidadeEnvios?: number;
  quantidadeErros?: number;
  investimentoAcumulado?: number;
}
